export default "<div *ngIf=\"isLoading | async\" class=\"overlay\">\r\n    <div class=\"spinner\"></div>\r\n</div>"